import {useIntl} from 'react-intl'
import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {formatData} from '../../../utils'

export const useGlobalSettingsContentful = () => {
    const {locale} = useIntl()
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const contentfulClient = useContentfulClient()

    useEffect(() => {
        contentfulClient
            .getEntries({
                locale,
                content_type: 'globalSettings',
                include: 10
            })
            .then((response) => {
                const items = response?.items ?? []
                const defaultConfig = items?.at(-1)?.fields ?? null

                if (defaultConfig) {
                    const {
                        defaultProductMedia = null,
                        plpViewStyle = 'infiniteList'
                    } = defaultConfig

                    setData({
                        ...defaultConfig,
                        plpViewStyle,
                        defaultProductMedia: formatData(defaultProductMedia)
                    })
                }
            })
            .catch((error) => setError(error))
            .finally(() => setIsLoading(false))
    }, [])

    return {isLoading, data, error}
}
